<template>
  <div class="w-100 p-2 mt-2">
    <page-header>
      <i class="fas fa-list"></i>
      {{ $t('page.title.players_list') }}
    </page-header>
    <page-card>
      <template v-slot:header>
        {{ $t('page.filters')}}
      </template>
      <template v-slot:content>
        <div class="sygni-grid">
            <div class="row">
              <div class="col-4">
                <filter-input
                    :filter-query="filterQuery"
                    @store="storeFilter"
                    :store-data="filters"
                    filter-name="phrase"
                    :label="$t('filters.label.player_phrase')"
                    :placeholder="$t('filters.placeholder.player_phrase')">
                </filter-input>
              </div>

              <div class="col-4">
                <filter-input-with-operator
                    :filter-query="filterQuery"
                    @store="storeFilter"
                    :store-data="filters"
                    :operator-options="filterOptions.comparisonOperator"
                    :operator-multiple="false"
                    :default-operator="{value: 'eq', text: 'equales'}"
                    :restrict-input="true"
                    restriction-type="decimals"
                    filter-name="depositCount"
                    :label="$t('filters.label.deposit_count')"
                >
                </filter-input-with-operator>
              </div>

              <div class="col-4">
                <filter-select
                    @store="storeFilter"
                    :store-data="filters"
                    :filter-query="filterQuery"
                    :options="filterOptions.status"
                    :multiple="false"
                    options-label="text"
                    options-track-by="value"
                    filter-name="status"
                    :label="$t('filters.label.status')"
                    :placeholder="$t('filters.placeholder.status')">
                </filter-select>
              </div>
            </div> <!-- #row -->

            <div class="row">
              <div class="col-4">
                <filter-input
                    :filter-query="filterQuery"
                    @store="storeFilter"
                    :store-data="filters"
                    filter-name="phone"
                    :label="$t('filters.label.phone')"
                    :placeholder="$t('filters.placeholder.phone')">
                </filter-input>
              </div>

              <div class="col-4">
                <filter-input-with-operator
                    :filter-query="filterQuery"
                    @store="storeFilter"
                    :store-data="filters"
                    :operator-options="filterOptions.comparisonOperator"
                    :operator-multiple="false"
                    :default-operator="{value: 'eq', text: 'equales'}"
                    :restrict-input="true"
                    restriction-type="decimals"
                    filter-name="quizCoinAmount"
                    :label="$t('filters.label.quiz_coins_balance')"
                >
                </filter-input-with-operator>
              </div>

              <div class="col-4">
                <filter-date-range-picker
                    :filter-query="filterQuery"
                    @store="storeFilter"
                    :store-data="filters"
                    :locale="{firstDay: 1, format: 'yyyy-mm-dd'}"
                    :auto="true"
                    :linked="false"
                    :time-picker="true"
                    filter-name="createdAt"
                    open-direction="left"
                    :label="$t('filters.label.registered_at')">
                </filter-date-range-picker>
              </div>
            </div> <!-- #row -->

            <div class="row">
              <div class="col-4">
                <filter-select
                    :filter-query="filterQuery"
                    @store="storeFilter"
                    :store-data="filters"
                    :options="countries"
                    :multiple="false"
                    options-track-by="value"
                    options-label="text"
                    filter-name="country"
                    :label="$t('filters.label.country')"
                    :placeholder="$t('filters.placeholder.country')">
                </filter-select>
              </div>

              <div class="col-4">
                <filter-input-with-operator
                    :filter-query="filterQuery"
                    @store="storeFilter"
                    :store-data="filters"
                    :operator-options="filterOptions.comparisonOperator"
                    :operator-multiple="false"
                    :default-operator="{value: 'eq', text: 'equales'}"
                    :restrict-input="true"
                    restriction-type="decimals"
                    filter-name="funCoinAmount"
                    :label="$t('filters.label.fun_coins_balance')"
                >
                </filter-input-with-operator>
              </div>

              <div class="col-4">
                <filter-date-range-picker
                    :filter-query="filterQuery"
                    @store="storeFilter"
                    :store-data="filters"
                    :locale="{firstDay: 1, format: 'yyyy-mm-dd'}"
                    :auto="true"
                    :time-picker="true"
                    :linked="false"
                    filter-name="lastLogin"
                    open-direction="left"
                    :label="$t('filters.label.last_login_at')">
                </filter-date-range-picker>
              </div>
            </div> <!-- #row -->

          <div class="row">
            <div class="col-4">
              <filter-input
                  :filter-query="filterQuery"
                  @store="storeFilter"
                  filterOperator="like"
                  :store-data="filters"
                  filter-name="btag"
                  :label="$t('filters.label.btag')"
                  :placeholder="$t('filters.placeholder.btag')">
              </filter-input>
            </div>
          </div> <!-- #row -->
        </div>
      </template>
      <template v-slot:footer>
        <b-checkbox @change="setPlayersOnlineFilter($event)">
          <span class="font-weight-normal">{{ $t('filters.label.show_players_online') }}</span>
        </b-checkbox>
        <b-button @click="resetFilters()" variant="secondary">{{$t('filters.btn.clear')}}</b-button>
        <b-button @click="applyFilters()" variant="primary">{{$t('filters.btn.apply')}}</b-button>
      </template>
    </page-card>

    <page-card>
      <template v-slot:header>
        {{ $t('page.list')}}
      </template>
      <template v-slot:content>
        <div class="sygni-grid">

          <div class="row mt-2">
            <div class="col-12">
              <grid-pagination :total-count="totalCount"
                               :per-page="perPage"
                               :current-page="currentPage"
                               @load-items="paginationReload"></grid-pagination>

              <div class="table-responsive">
                <b-table striped show-empty
                         :empty-text="$t('table.no_results')"
                         :busy="isBusy"
                         hover
                         head-variant="dark"
                         outlined
                         :sort-by.sync="orderColumn"
                         :sort-desc.sync="orderDirection"
                         :no-local-sorting="true"
                         :items="items"
                         :fields="fields">


                  <template #cell(status)="data">
                    <b-badge pill variant="danger" v-if="data.value === 900">{{ $t('player_status_'+data.value) }}</b-badge>
                    <b-badge pill class="lock-player-status" v-if="data.value === 100">{{ $t('player_status_'+data.value) }}</b-badge>
                    <b-badge pill variant="success" v-if="data.value === 30">{{ $t('player_status_'+data.value) }}</b-badge>
                    <b-badge pill variant="primary" v-if="data.value === 20">{{ $t('player_status_'+data.value) }}</b-badge>
                    <b-badge pill variant="warning" v-if="data.value === 10">{{ $t('player_status_'+data.value) }}</b-badge>
                  </template>

                  <template #cell(nickName)="data">
                    <div class="d-flex align-items-center">
                      <div class="player-online-dot-container">
                        <div v-if="data.item.online" class="player-online-dot"></div>
                      </div>
                      {{ data.value }}
                    </div>
                  </template>

                  <template #cell(createdAt)="data">
                    {{ data.value | dateFormat('YYYY-MM-DD HH:mm') }}
                  </template>

                  <template #cell(lastLogin)="data">
                    {{ data.value | dateFormat('YYYY-MM-DD HH:mm') }}
                  </template>

                  <template #cell(country)="data">
                    <div class="table-flag--wrapper" v-if="data.value">
                  <span>
                  <img
                      :src="getImgUrl(data.value)"
                      class="table-flags"
                  >
                    {{ data.value.toUpperCase() }}
                  </span>
                    </div>
                  </template>

                  <template #cell(quizCoinAmount)="data">
                    {{ data.value | numberFormat }}
                  </template>

                  <template #cell(funCoinAmount)="data">
                    {{ data.value | numberFormat }}
                  </template>

                  <template #cell(actions)="data">
                    <div class="table-action--cell">
                      <b-button variant="primary" size="sm"
                                @click="showItemDetails(data.item)">
                        {{ $t('table.btn.show') }}
                      </b-button>
                    </div>
                  </template>

                  <template #table-busy>
                    <div class="text-center text-danger my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong>{{$t('state.loading')}}</strong>
                    </div>
                  </template>

                </b-table>
              </div> <!-- #table-responsive-->

              <grid-pagination :total-count="totalCount"
                               :per-page="perPage"
                               :current-page="currentPage"
                               @load-items="paginationReload"></grid-pagination>

            </div>
          </div>
        </div>
      </template>
    </page-card>
  </div>
</template>

<script>

import FilterSelect from "../../../components/grid/filters/FilterSelect";
import FilterInput from "../../../components/grid/filters/FilterInput";
import FilterInputWithOperator from "../../../components/grid/filters/FilterInputWithOperator";
import FilterDateRangePicker from "../../../components/grid/filters/FilterDateRangePicker";
import GridPagination from "../../../components/grid/grid-pagination/GridPagination";
import PageHeader from "../../../components/page/PageHeader";
import PageCard from "../../../components/page/PageCard";
import {mapState} from "vuex";

export default {
  props: ['apiKey'],
  components: {
    PageCard,
    PageHeader,
    GridPagination,
    FilterSelect,
    FilterInput,
    FilterInputWithOperator,
    FilterDateRangePicker,
  },
  data() {
    return {
      orderColumn: 'createdAt',
      orderDirection: false,
      fields: [
        // {key: 'id'},
        {key: 'name', label: this.$t('table.header.first_name_last_name')},
        {key: 'nickName', label: this.$t('table.header.nick_name')},
        {key: 'email', label: this.$t('table.header.email')},
        {key: 'phone', label: this.$t('table.header.phone')},
        {key: 'country', label: this.$t('table.header.country'), sortable: true},
        {key: 'status', label: this.$t('table.header.status'), sortable: true},
        {key: 'depositCount', label: this.$t('table.header.deposit_count'), sortable: true},
        {key: 'quizCoinAmount', label: this.$t('table.header.quizcoins_balance'), sortable: true},
        {key: 'funCoinAmount', label: this.$t('table.header.funcoins_balance'), sortable: true},
        {key: 'btag', label: this.$t('table.header.btag'), sortable: true},
        {key: 'createdAt', label: this.$t('table.header.registred_at'), sortable: true},
        {key: 'lastLogin', label: this.$t('table.header.last_login_at'), sortable: true},
        {key: 'actions', label: this.$t('table.header.actions')},
      ],
      selectOptions: {
        status: [
          {value: 20, text: 'published'},
          {value: 10, text: 'draft'},
        ],
        type: [
          {value: 'text', text: 'text'},
          {value: 'image', text: 'image'},
          {value: 'sound', text: 'sound'},
          {value: 'video', text: 'video'},
        ],
        containOperator: [
          {value: 'eq', text: this.$t('operator.contains')},
          {value: 'neq', text: this.$t('operator.not_contains')},
        ],
        comparisonOperator: [
          {value: 'eq', text: this.$t('operator.equales')},
          {value: 'gte', text: this.$t('operator.greater_then')},
          {value: 'lte', text: this.$t('operator.lower_than')},
          {value: 'btw', text: this.$t('operator.between')},
        ],
        bulkActions: [
          {value: null, text: 'Bulk actions'},
          {value: 'export', text: 'Export'},
          {value: 'delete', text: 'Delete'},
        ],
        difficulty: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
        lang: [],
        category: [],
      },
      filterQuery: [],
      filterOptions: {
        lobbyId: [
          {value: 'INSTANT', text: 'Instant'},
          {value: 'SIT_AND_GO', text: 'Sit & Go'}
        ],
        country: [
          {value: 'PL', text: 'Poland'},
          {value: 'DE', text: 'Germany'},
          {value: 'FR', text: 'France'},
        ],
        status: [
          {value: 10, text: this.$t('player_status_10')},
          {value: 20, text: this.$t('player_status_20')},
          {value: 30, text: this.$t('player_status_30')},
          {value: 100, text: this.$t('player_status_100')},
          {value: 900, text: this.$t('player_status_900')}
        ],
        walletCurrency: [
          {value: 'FUN_COINS', text: 'Free Coins'},
          {value: 'QUIZ_COINS', text: 'Quiz Coins'}
        ],
        maxPlayers: [
          {value: '2', text: '2'},
          {value: '3', text: '3'},
          {value: '4', text: '4'}
        ],
        comparisonOperator: [
          {value: 'eq', text: this.$t('operator.equales')},
          {value: 'gte', text: this.$t('operator.greater_then')},
          {value: 'lte', text: this.$t('operator.lower_than')},
          {value: 'btw', text: this.$t('operator.between')},
        ],
        category: [],
      },
    };
  },
  mounted() {
    // this.getData('/api/lobby/configuration', ['filterOptions', 'lobbyId']);
    if (this.apiKey) {
      this.$store.commit('root/setApiKey', this.apiKey);
    }
    this.loadItems();
    if(!this.filters) {
      this.initFilters();
    }
    document.addEventListener('keydown', this.bindEnter);
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.bindEnter);
  },
  computed: {
    ...mapState({
      perPage: (state) => state.players.perPage,
      currentPage: (state) => state.players.currentPage
    }),
    filters: function () {
      return this.$store.getters["root/filter"]('players');
    },
    isBusy: function () {
      return this.$store.getters["players/isBusy"];
    },
    items: function () {
      return this.$store.getters["players/items"];
    },
    countries: function () {
      return this.$store.getters["root/country"].map(d => {
        return {
          text: d.label,
          value: d.key
        }
      });
    },
    totalCount: function () {
      return this.$store.getters["players/totalCount"];
    },
  },
  methods: {
    storeFilter(data) {
      this.$store.commit('root/setFilter', {storeName: 'players', ...data})
    },
    createSortQuery() {
      let sorting;
      if (this.orderColumn) {
        if (this.orderDirection === true) {
          sorting = encodeURIComponent('+' + this.orderColumn);
        } else {
          sorting = encodeURIComponent('-' + this.orderColumn);
        }
        return '&sort[]=' + sorting;
      }
      return '';
    },
    bindEnter(e) {
      if (e.keyCode === 13) {
        this.applyFilters();
      }
    },
    loadItems() {
      this.$store.dispatch('players/loadItems', {
        params: {
          offset: this.perPage * (this.currentPage - 1),
          limit: this.perPage
        },
        filters: this.filterQuery,
        sort: this.createSortQuery()
      });
    },
    applyFilters: function () {
      this.currentPage = 1;
      this.loadItems();
    },
    resetFilters() {
      this.filterQuery = [];
      this.$root.$emit('resetFilters');
      this.initFilters();
      this.applyFilters();
    },
    initFilters() {
      this.$store.commit('root/initFilters', {
        storeName: 'players',
        filterNames: ['phrase', 'phone', 'depositCount', 'status', 'quizCoinAmount', 'funCoinAmount', 'lastLogin', 'createdAt']
      });
    },
    showItemDetails(item) {
      this.$router.push({name: 'player-details', params: {id: item.id}});
    },
    paginationReload(data) {
      this.currentPage = this.$store.commit('players/setCurrentPage', data.currentPage);
      this.$store.commit('players/setPerPage', data.perPage);
      this.loadItems();
    },
    getImgUrl(country) {
      let images = require.context('@/assets/flags');
      let imgSrc;

      try {
        imgSrc = images(`./${country.toLowerCase()}.svg`);
      } catch {
        imgSrc = '';
      }

      return imgSrc;
    },
    setPlayersOnlineFilter(e) {
      if (e) {
        this.filterQuery['online'] = '&filters[online][0][value]=true&filters[online][0][operator]=eq';
      } else {
        delete this.filterQuery['online'];
      }

      this.applyFilters();
    }
  },
  watch: {
    orderColumn: function () {
      this.loadItems();
    },
    orderDirection: function () {
      this.loadItems();
    }
  }
}
</script>
